import React, { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {login,AsterConfig,LoginUserinfo} from '../redux/action/login.js'
import "../assets/css/loginpage.css"
import Comtemplete from '../page/comtemplete.js';

function Login() {
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const dispatch = useDispatch();
  const loginlocal = localStorage.getItem('login'); // Access the token from localStorage
  useEffect(() => {
   
    //Runs only on the first render
    if (loginlocal == "true") {
     window.location.href = `/callpopup`;
       
    }else{
      console.log("Loginelse");
    }
    
  }, []);
    
  useEffect(() => {
   
   window.addEventListener('message', handleMessage);
    return () => {

        console.log("Removelistener")

        window.removeEventListener('message', handleMessage);

    };


}, []);

const handleMessage = async (event) => {

try {
  console.log("loginlistener===========>",event.data);

  const stationnumber = event.data.user_number
  if (stationnumber !== null && stationnumber !== undefined) {
    console.log("testcondiion");
    localStorage.setItem('crmuserinfo',JSON.stringify(event.data))
    localStorage.setItem('station', stationnumber)  
  }
  

} catch (error) {
  console.log("error1234",error);
}


}


  const handleLogin = () => {
    setIsLoggingIn(true);
    dispatch(login(username, password)).then((additionalData) => {
    if (additionalData.status === 200) {
    const storedApinfo = localStorage.getItem('apinfo'); 
    const apiinfo = JSON.parse(storedApinfo);
     const doocti_tenent =apiinfo.tenant_code;
     setIsLoggingIn(false);
     
    dispatch(AsterConfig(username,doocti_tenent))
    .then((response) => {
      if (response.status === 200) {
       window.location.href='/queuepage';   
        let data = JSON.stringify(response.data)
        localStorage.setItem("config", data)
        let config_user = response.data.projects[0].userInfo[0].user_email
        localStorage.setItem('username',config_user)
        
    
      }
      
    })
    .catch((err) => {
      
     console.log("ConfigError===========>",err);
    });
    
   }
    
  })
  .catch((error) => {
    // Handle login error
    setIsLoggingIn(false);
    console.error('Login failed:', error);
  });
       };
  return (
   
    <div>
    <Comtemplete>
    
    <div className="login-box">
    
      <form>
        <div className="form-group">
          <label htmlFor="username">UserEmail</label>
          <input className='logininput' type="text" placeholder="abcdef@doocti.com" value={username} onChange={(e) => setUsername(e.target.value)} />

        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          {/* <input type="password" id="password" /> */}
          <input className='logininput' type="password" placeholder="1234" value={password} 
          onChange={(e) => setPassword(e.target.value)} />

       
        </div>

        <button type="button" className="login-button" onClick={handleLogin}  disabled={isLoggingIn}   >
        {isLoggingIn ? 'Logging In...' : 'Login'}
          </button>
      </form>
    
    
    
    </div>
    </Comtemplete>
 
  </div>    

   );

}

export default Login;
